export default __webpack_public_path__ + "static/media/yogurt1.f343aee9.jpg";